import React, { useEffect, useRef, useState } from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { showToast } from "../../Components/Toast";
import { useDispatch, useSelector, connect } from "react-redux";
import { setBillInfo } from "../../Redux/Actions";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { ReactComponent as Delete } from "../../assets/icons/delete.svg";
const SMSPay = ({ setBillToPay, isLogin }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const [error, setError] = useState(false);
  const [state, setState] = useState("");
  const [disable, setDisable] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [regex, setRegex] = useState({});
  const textInputRef = useRef(null);
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    getRegex();
  }, []);
  function getRegex() {
    ApiCall(
      "get",
      "V1/Base/Category?content_name=SMSRegex",
      {},
      "Get Content",
      null,
      (res) => {
        const { content } = res.data;
        const regBillId = content.find((e) => e.title == "BillIdRegex")
          ?.description;
        const regPayId = content.find((e) => e.title == "PayIdRegex")
          ?.description;
        setRegex({ regBillId, regPayId });
        setLoading(false);
      },
      (err) => setLoading(false)
    );
  }
  function checkString(sms) {
    sms += "\n";
    let lines = sms.match(/(.*\n)/g);
    let billId = "";
    let payId = "";
    const regBillId = new RegExp(regex.regBillId);
    const regPayId = new RegExp(regex.regPayId);
    if (
      Array.isArray(lines) &&
      lines.length > 1 &&
      sms.match(regBillId) &&
      sms.match(regPayId)
    ) {
      setError(false);
      lines.forEach((el) => {
        if (el.match(regBillId)) billId = el.match(/\d/g)?.join("");
        if (el.match(regPayId)) payId = el.match(/\d/g)?.join("");
      });

      setState({
        billId,
        payId,
      });
    } else setError(true);
  }
  function emptyBox() {
    setState({});
    setError(false);
    // console.log(textInputRef.current);
    textInputRef.current.value = "";
  }
  const history = useHistory();
  function onSubmit() {
    setDisable(true);
    const integerBillId = parseInt(state.billId);
    const integerPayId = parseInt(state.payId);
    const url = `V1/Bill/Inquiry/BillPay?bill_id=${integerBillId}&pay_id=${integerPayId}`;
    ApiCall(
      "get",
      url,
      {},
      "Bill",
      token,
      (result) => {
        setDisable(false);
        if (result.data != null) {
          const isPaid = result.data.payment_status == 1 ? true : false;
          if (isPaid) {
            showToast(
              "قبض مورد نظر به وسیله کنتور پرداخت شده است. برای مشاهده به سوابق پرداخت مراجعه نمایید.",
              "#f6b517"
            );
          } else {
            setBillToPay({ ...result.data, paymentType: "SMS" });
            history.push("billInfo");
          }
        }
      },
      (err) => setDisable(false)
    );
  }

  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text={"پرداخت مستقیم پیامک‌های دریافتی"} />
        <div className="SMSPayPage">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 className="SMSPayH3">
              لطفا متن پیامک دریافتی از سازمان مورد نظر را در باکس زیر کپی
              نمایید
            </h3>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                // height: window.innerHeight * 0.05,
                alignItems: "center",

                justifyContent: "space-between",
              }}
            >
              <div className="DeleteTextSVG">
                <h5 onClick={() => emptyBox()} className="SMSPayH4">
                  حذف متن
                </h5>
                <Delete />
              </div>
              <h4 className="SMSPayH4">متن پیام</h4>
            </div>
            <textarea
              rows="4"
              cols="50"
              placeholder="متن پیامک را الصاق کنید"
              ref={textInputRef}
              onChange={(value) => checkString(value.target.value)}
            ></textarea>
            <span
              style={{ color: !!state.billId && "#27ae60" }}
              className="SMSPaySpan"
            >
              {error
                ? "متن پیام وارد شده معتبر نمیباشد"
                : !!state.billId
                ? "لطفا شناسه قبض و پرداخت را بررسی نمایید"
                : " "}
            </span>
          </div>
          <div className={"SMSPayBillPart"}>
            {!!state.billId && !!state.payId && (
              <>
                <div>
                  <h5>شناسه قبض</h5>
                  <span>{state.billId}</span>
                </div>
                <div>
                  <h5>شناسه پرداخت</h5>
                  <span>{state.payId}</span>
                </div>
                <div className="SMSPayBTN" onClick={() => onSubmit()}>
                  {isLoading ? (
                    <Loader
                      type="ThreeDots"
                      color="white"
                      height={5}
                      width={20}
                    />
                  ) : (
                    <span>تایید اطلاعات و پرداخت قبض</span>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    billInfo: state.auth.billInfo,
    token: state.auth.token,
    isLogin: state.auth.isLogin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBillToPay: (info) => dispatch(setBillInfo(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SMSPay);
